import React, { useState } from "react"
import { useCheckoutState } from "../../checkout/state"
import { Product } from "../../checkout/product"
import { Button } from "../ui/Button"
import Modal from "../../components/ui/Modal"
import { Box, Divider } from "@mui/material"
import { formatCurrencyString } from "../../utils/format"
import { Membership } from "../user/subscriptions/membership"
import { LineItem } from "../user/subscriptions/subscription"

const ProductPriceTiers = ({
  displayLinkText,
  product,
  membership,
  lineItem,
  numHighlight,
  infoIcon,
}: {
  displayLinkText: string
  product?: Product
  membership?: Membership
  lineItem?: LineItem
  numHighlight?: number
  infoIcon?: boolean
}) => {
  const checkoutState = useCheckoutState()
  const { currency } = checkoutState

  if ((!product && !membership) || (membership && !lineItem)) {
    return <div />
  }

  const numIncluded =
    product?.getNumIncluded(currency) ?? membership!.getNumIncluded(lineItem!)
  const priceTiers =
    product?.getPriceTiers(currency) ?? membership!.getPriceTiers(lineItem!)

  const [isOpen, setIsOpen] = useState<boolean>(false)

  return (
    <Box sx={{ display: "inline-block", a: { display: "inline" } }}>
      <Button
        type={"link"}
        title={displayLinkText}
        sectionId="tiers"
        id={"view"}
        onClick={() => {
          setIsOpen(!isOpen)
        }}
        icon={infoIcon ? "info-circle" : ""}
      />

      <Modal setIsOpen={setIsOpen} isOpen={isOpen}>
        <Box sx={{ width: "350px" }}>
          <Box
            sx={{ fontSize: "1.2rem", lineHeight: "1.6rem", fontWeight: 600 }}
          >
            All sessions charged based on the total sessions completed.
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              margin: "1rem 0",
              fontWeight: 600,
              color: "var(--color-teal)",
            }}
          >
            <Box sx={{ width: "200px", textAlign: "center" }}>
              Completed Sessions
            </Box>
            <Box sx={{ width: "150px", textAlign: "right" }}>Rate Charged</Box>
          </Box>
          {priceTiers.map((t, i) => {
            const highlight =
              numHighlight &&
              t.start <= numHighlight &&
              (!t.limit || t.limit >= numHighlight)
            return (
              <Box key={i}>
                <Divider />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    margin: "1rem 0",
                    fontWeight: highlight ? 600 : 400,
                  }}
                >
                  <Box sx={{ width: "200px", textAlign: "center" }}>
                    {t.limit ? `${t.start}+` : t.start + "+"}
                  </Box>
                  <Box sx={{ width: "150px", textAlign: "right" }}>
                    {formatCurrencyString({ currency, value: t.amount })}
                  </Box>
                </Box>
              </Box>
            )
          })}
          {numIncluded > 0 && (
            <Box
              sx={{
                margin: "1.75rem 0 1em 0",
                fontSize: "1.15rem",
                fontStyle: "italic",
                textAlign: "center",
                color: "var(--color-teal)",
                width: "350px",
                fontWeight: "600",
              }}
              className="gradientText"
            >
              Your first {numIncluded} sessions are free with your membership.
            </Box>
          )}
        </Box>
      </Modal>
    </Box>
  )
}

export default ProductPriceTiers
